import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { countCellsSelected } from 'modules/shift_management/hooks/useCountCellsSelected'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import {
  useSelectionDispatch,
  useSelectionState,
} from 'modules/shift_management/hooks/useSelection'
import { trackAddShiftStartEvent } from 'modules/shift_management/lib/trackEvents'
import { ShiftsRow } from 'modules/shift_management/lib/types'
import type DefaultShifts from 'modules/shift_management/store/internal/collections/DefaultShifts'

import AddButton from './AddButton'
import AddShiftSidepanel from './AddShiftSidepanel'
import QuickActionsPopover from './QuickActionsPopover'

interface Props {
  shiftsRow: ShiftsRow
  date: moment.Moment
  visibleDefaultShifts: DefaultShifts
}

const AddShiftContextualButton = ({ shiftsRow, date, visibleDefaultShifts }: Props) => {
  const [openAddShiftSidepanel, setOpenAddShiftSidepanel] = React.useState<boolean>(false)
  const [{ view }] = useSchedule()
  const { daysByRow, shifts, restDays } = useSelectionState()

  const dispatchSelection = useSelectionDispatch()

  const onCloseShiftSidepanel = () => {
    setOpenAddShiftSidepanel(false)
  }

  const onOpenAddShiftSidepanel = () => {
    const selectedEmployees = Object.keys(daysByRow).length
    const impactedEmployees = selectedEmployees || 1

    const cellCount = countCellsSelected({ daysByRow, shifts, restDays, view })
    const impactedShifts = cellCount || 1
    // Forcing to enable the day if it's not selected.
    dispatchSelection({
      type: 'TOGGLE_DAY',
      day: date,
      shiftsRow,
      view,
      forcedValue: true,
    })
    trackAddShiftStartEvent({
      view,
      impactedEmployees,
      cellCount: impactedShifts,
      shiftType: 'savedCustom',
      from: 'contextual_button',
    })
    setOpenAddShiftSidepanel(true)
  }

  // We will not show quick actions and open the side panel directly
  if (view.isByAreas) {
    return (
      // Stop propagation to avoid unselecting the cell on the background.
      <Box onClick={(ev) => ev.stopPropagation()}>
        <AddButton onClick={onOpenAddShiftSidepanel} />
        {openAddShiftSidepanel && <AddShiftSidepanel onClose={onCloseShiftSidepanel} date={date} />}
      </Box>
    )
  }

  return (
    <QuickActionsPopover
      date={date}
      shiftsRow={shiftsRow}
      visibleDefaultShifts={visibleDefaultShifts}
    />
  )
}

export default observer(AddShiftContextualButton)
